/**
 * Русский словарь интерфейса.
 *
 * Разрезан по языкам не ради красоты: файл трогает почти любая задача по
 * интерфейсу, и правка русского текста не должна тянуть в контекст узбекский.
 *
 * Строк в коде нет: иначе добавление языка превращается в проход по всем
 * файлам заново. Контентные тексты (названия товаров) локализует сервер.
 */

export const ru = {
  appName: 'Арбуз',
  tagline: 'Доставка бахчевых по Ташкенту',
  welcomeTitle: 'Сочный арбуз\nс доставкой!',
  welcomeText: 'Свежие и сладкие арбузы прямо к вашему дому',
  orderWatermelon: 'Заказать арбуз',
  howWorks: 'Как это работает?',
  setupTitle: 'Настройка профиля',
  setupHeading: 'Куда привезти арбуз?',
  setupText: 'Добавьте телефон и адрес, чтобы курьер смог связаться с вами.',
  phoneTitle: 'Номер телефона',
  phoneTelegramOnly: 'Через Telegram, без ручного ввода',
  addressSetupHint: 'Укажите точку и детали адреса',
  continueOrder: 'Сохранить и продолжить',
  homeHeroTitle: 'Закажите свежий арбуз с доставкой',
  homeHeroText: 'Мы привезём спелый арбуз прямо к вашему дому',
  homeBenefits: 'Преимущества заказа',
  benefitQuality: 'Отборные арбузы',
  benefitQualityText: 'Только спелые и сладкие',
  benefitDelivery: 'Быстрая доставка',
  benefitDeliveryText: 'В удобное для вас время',
  benefitOrder: 'Удобный заказ',
  benefitOrderText: 'Адрес, время и количество',
  benefitContact: 'На связи до доставки',
  benefitContactText: 'Уточним адрес и время',
  selectWatermelonTitle: 'Выберите арбуз',
  selectWatermelonText: 'Показываем предложения, доступные для вашего адреса.',
  availableForAddress: 'Доступно по адресу',
  deliveryArea: 'Исполнитель и доставка',
  selectBeforeCheckout: 'Выберите арбуз',
  catalogHome: 'Главная',
  favorites: 'Избранное',
  quantityTitle: 'Количество арбузов',
  productUnavailable: 'Товар больше не продаётся. Вернитесь на главную и выберите доступный товар.',
  approxWeightOne: 'Средний вес одного',
  totalApprox: 'Итого примерно',
  totalToPay: 'Итого к оплате',
  paymentConfirmTitle: 'Подтвердите заказ',
  payOnDelivery: 'К оплате при получении',
  paymentCashShort: 'Наличными',
  paymentCardShort: 'Переводом на карту',
  deliveryIncluded: 'доставка включена',
  deliveryContactTitle: 'Мы свяжемся перед доставкой',
  deliveryContactText: 'Проверим адрес и привезём в выбранное окно',
  catalog: 'Каталог',
  orders: 'Заказы',
  profile: 'Профиль',
  checkout: 'Оформить заказ',
  total: 'Итого',
  sum: 'сум',
  kg: 'кг',
  approxWeight: 'Примерный вес',
  emptyCatalog: 'Каталог пока пуст',
  emptyCatalogHint: 'Товары появятся совсем скоро.',
  goToCatalog: 'Перейти в каталог',
  loadError: 'Не удалось загрузить каталог',
  retry: 'Повторить',
  needPhoneTitle: 'Нужен номер телефона',
  soon: 'Оформление заказа появится на следующем этапе.',
  sizeS: 'Небольшой',
  sizeM: 'Средний',
  sizeL: 'Большой',
  decrease: 'Уменьшить количество',
  increase: 'Увеличить количество',
  addressTitle: 'Адрес доставки',
  useMyLocation: '📍 Моё местоположение',
  pickOnMap: 'Указать на карте',
  hideMap: 'Скрыть карту',
  mapLoading: 'Карта загружается…',
  pointNotSet: 'Точка не указана. Отправьте геолокацию или укажите на карте.',
  checkingZone: 'Определяем зону…',
  deliveryPrice: 'Доставка',
  outOfZone: 'По этому адресу доставка пока недоступна',
  streetLabel: 'Улица и район',
  houseLabel: 'Дом',
  apartmentLabel: 'Квартира',
  entranceLabel: 'Подъезд',
  floorLabel: 'Этаж',
  landmarkLabel: 'Ориентир (по желанию)',
  saveAddress: 'Сохранить адрес',
  saving: 'Сохранение…',
  addressSaved: 'Адрес сохранён',
  changeAddress: 'Изменить адрес',
  slotTitle: 'Удобное время доставки',
  checkComposition: 'Проверьте состав',
  confirmTitle: 'Проверьте ваш заказ',
  confirmOrder: 'Подтвердить заказ',
  next: 'Далее',
  pcs: 'шт.',
  commentLabel: 'Комментарий (по желанию)',
  commentPlaceholder: 'Например: нужен очень сладкий',
  paymentTitle: 'Способ оплаты',
  paymentCash: 'Наличными при получении',
  paymentCard: 'Переводом на карту',
  noAddressYet: 'У вас пока нет сохранённых адресов.',
  addAddress: 'Добавить адрес',
  orderAccepted: 'Заказ принят!',
  orderAcceptedText: 'Спасибо! Мы свяжемся с вами и доставим заказ в указанное время.',
  orderNumber: 'Номер заказа',
  toMyOrders: 'Перейти в мои заказы',
  toHome: 'На главную',
  slotReason_full: 'Это время уже занято',
  slotReason_lead_time: 'Слишком близко ко времени доставки',
  slotReason_closed: 'В этот день не возим',
  slotReason_past: 'Время уже прошло',
  activeOrders: 'Активные',
  completedOrders: 'Завершённые',
  noOrders: 'Заказов пока нет',
  cancelOrder: 'Отменить заказ',

  // ── Курьер ────────────────────────────────────────────────────────────
  courierDeliveries: 'Мои доставки',
  courierProfile: 'Профиль',
  courierNoActive: 'Назначенных доставок нет',
  courierNoActiveHint: 'Новый заказ придёт уведомлением в этот же чат.',
  courierNoCompleted: 'Завершённых доставок пока нет',
  courierOrder: 'Заказ',
  clientLabel: 'Клиент',
  addressLabel: 'Адрес',
  callClient: 'Позвонить',
  openMap: 'Открыть на карте',
  toCollect: 'К оплате',
  markAssembled: 'Заказ собран',
  markOnTheWay: 'Выехал к клиенту',
  markDelivered: 'Вручить заказ',
  markFailed: 'Не удалось доставить',
  deliverTitle: 'Вручение заказа',
  collectedLabel: 'Принятая сумма',
  collectedHint: 'Если сумма отличается от итога — исправьте, расхождение увидит администратор.',
  confirmDelivery: 'Подтвердить вручение',
  failTitle: 'Доставка не состоялась',
  failReasonLabel: 'Что произошло',
  failCommentLabel: 'Подробности (по желанию)',
  confirmFail: 'Отметить как недоставленный',
  failReason_no_answer: 'Клиент не отвечает',
  failReason_wrong_address: 'Адрес указан неверно',
  failReason_client_refused: 'Клиент отказался',
  failReason_unreachable: 'До адреса не добраться',
  failReason_other: 'Другое',
  pickupTitle: 'Точка сборки',
  pickupHint: 'Отсюда вы забираете заказы. Точка видна администратору и пригодится при планировании маршрутов.',
  pickupAddressLabel: 'Адрес точки сборки',
  pickupNotSet: 'Точка сборки не задана',
  savePickup: 'Сохранить точку сборки',
  pickupSaved: 'Точка сборки сохранена',
  clearPickup: 'Убрать точку',
  languageLabel: 'Язык',
  actionFailed: 'Не удалось выполнить действие',
  networkError: 'Нет связи с сервером',
  ordersLoadError: 'Не удалось загрузить доставки',
  amountInvalid: 'Укажите сумму числом',
  courierHome: 'Главная',
  executorLabel: 'Исполнитель',
  nextOrder: 'Ближайший',
  openOrder: 'Открыть',
  vendorStatus: 'Витрина',
  vendorWorking: 'Работает',
  readiness: 'Готовность',
  readyOf: 'из',
  quickActions: 'Быстрые действия',
  currentOrders: 'Текущие заказы',
  currentOrdersHint: 'В работе',
  productPriceAvailability: 'Цена и наличие',
  zoneMapDelivery: 'Карта и доставка',
  profileContactPayment: 'Связь и оплата',
  ordersInWork: 'В работе',
  orderHistory: 'История',
  executorProfile: 'Профиль исполнителя',
  profileSettings: 'Настройки',
  deliveries: 'доставки',

  // ── Кабинет исполнителя ───────────────────────────────────────────────
  shopTitle: 'Моя витрина',
  shopOpen: 'Принимаю заказы',
  shopClosed: 'Заказы не принимаю',
  shopOpenHint: 'Пока витрина выключена, клиенты вас не видят.',
  shopChecklist: 'Что нужно, чтобы начать',
  shopNeedProducts: 'Добавьте хотя бы один товар',
  shopNeedZones: 'Задайте зону доставки',
  shopNeedSchedule: 'Отметьте рабочие дни',
  shopReady: 'Всё готово — можно включать витрину',
  shopSectionProducts: 'Товары',
  shopSectionZones: 'Зона доставки',
  shopSectionSchedule: 'Часы работы',
  shopSectionPayout: 'Связь и оплата',
  shopNameLabel: 'Название витрины',
  shopNameHint: 'Так вас увидит клиент при выборе исполнителя.',
  shopCapacityLabel: 'Заказов в один слот',
  shopCapacityHint: 'Сколько доставок вы успеваете за один промежуток времени.',
  shopNone: 'Витрина ещё не заведена',
  shopNoneHint: 'Обратитесь к администратору — он заведёт вам витрину.',
  shopLoadError: 'Не удалось загрузить витрину',
  shopSaved: 'Сохранено',

  // Товары
  loading: 'Загружаем…',
  vendorsTitle: 'Кто привезёт',
  vendorsText: 'Показываем тех, кто возит по вашему адресу.',
  vendorsEmpty: 'По этому адресу пока никто не возит',
  vendorsEmptyHint: 'Попробуйте другой адрес — мы работаем не по всему городу.',
  vendorsEmptyPointHint:
    'Доставка считается по точке на карте, а не по названию адреса. Если точка стоит неточно — поправьте её.',
  vendorsAllClosed: 'Сегодня все закрыты',
  vendorsAllClosedHint: 'Можно оформить заказ на другой день.',
  vendorsLoadError: 'Не удалось загрузить список исполнителей',
  vendorFrom: 'от',
  vendorWorksToday: 'сегодня до',
  vendorClosedToday: 'сегодня не работает',
  vendorChange: 'Сменить исполнителя',
  vendorSwitchConfirm: 'В корзине товары другого исполнителя. Очистить корзину?',
  vendorLabel: 'Исполнитель',
  vendorGone: 'Этот исполнитель больше не возит по вашему адресу. Выберите другого.',
  cardTransferTitle: 'Реквизиты для перевода',
  cardTransferHint: 'Переведите сумму на карту и сообщите об этом исполнителю при доставке.',
  cardTransferMissing: 'Реквизиты пока не указаны — выберите оплату наличными.',
  back: 'Назад',
  productsCount: 'товаров',
  zonesCount: 'зон',
  productsEmpty: 'Товаров пока нет',
  productsEmptyHint: 'Добавьте то, что вы продаёте: тип, цену и фото.',
  productsLoadError: 'Не удалось загрузить товары',
  productAdd: 'Добавить товар',
  productEditTitle: 'Товар',
  productTypeLabel: 'Что продаёте',
  productTypeHint: 'Название товара клиент увидит по типу — придумывать его не нужно.',
  productTypesError: 'Не удалось загрузить типы товара',
  productPriceLabel: 'Цена за штуку, сум',
  productSizeLabel: 'Размер',
  productSizeNone: 'Не указан',
  productSizeS: 'Маленький',
  productSizeM: 'Средний',
  productSizeL: 'Большой',
  productWeightLabel: 'Вес, кг',
  productWeightFrom: 'от',
  productWeightTo: 'до',
  productDescriptionLabel: 'Описание',
  productAvailable: 'В продаже',
  productPhoto: 'Фото',
  productPhotoAdd: 'Снять или выбрать фото',
  productPhotoUploading: 'Загружаю фото…',
  productPhotoError: 'Не удалось загрузить фото',
  productSave: 'Сохранить товар',
  productRemove: 'Снять с продажи',
  productRemoveConfirm: 'Снять товар с продажи? Клиенты перестанут его видеть.',
  productHidden: 'Снят с продажи',

  // Зоны
  zonesEmpty: 'Зона доставки не задана',
  zonesEmptyHint: 'Обведите на карте район, куда вы возите, и укажите цену доставки.',
  zonesLoadError: 'Не удалось загрузить зоны',
  zoneAdd: 'Добавить зону',
  zoneEditTitle: 'Зона доставки',
  zoneNameLabel: 'Название зоны',
  zoneNameHint: 'Для вас, клиенту не показывается.',
  zonePriceLabel: 'Цена доставки, сум',
  zoneActive: 'Зона работает',
  zonePoints: 'точек в контуре',
  zoneAreaUnit: 'км²',
  zoneSave: 'Сохранить зону',
  zoneRemove: 'Удалить зону',
  zoneRemoveConfirm: 'Удалить зону? Клиенты перестанут видеть вас по этим адресам.',
  zoneNeedPoints: 'Обведите район: нужно минимум три точки',
  zoneHasOrders: 'По этой зоне уже были заказы — её можно выключить, но не удалить',
  zoneMapTitle: 'Контур зоны',
  zoneMapOpen: 'Изменить на карте',
  zoneMapDraw: 'Обвести район на карте',
  zonePreviewEmpty: 'Район ещё не обведён',
  zonePreviewHint: 'Обведите пальцем район, куда возите: карта откроется на весь экран.',
  zoneMapDone: 'Готово',
  zoneMapCancel: 'Отмена',
  zoneMapDiscard: 'Закрыть карту? Правки контура не сохранятся.',
  zoneMapToolDraw: 'Обвести',
  zoneMapToolPoints: 'Точки',
  zoneMapNoToolHint: 'Карту можно двигать и масштабировать. Выберите инструмент, чтобы рисовать.',
  zoneMapDrawHint: 'Проведите пальцем по карте, как карандашом, обводя район доставки.',
  zoneMapPointsHint: 'Нажимайте по карте, чтобы поставить вершины. Тап по вершине удалит её.',
  zoneMapUndo: 'Отменить',
  zoneMapPoints: 'Точек',
  zoneMapNeedMore: 'нужно минимум 3',
  zoneMapCrossing: 'Линии контура пересекаются — поправьте точки',
  zoneMapReset: 'Сбросить',
  zoneMapResetConfirm: 'Убрать контур целиком?',
  zoneMapAria: 'Карта редактирования зоны доставки',
  zoneCheaperHint: 'Если зон несколько и они накладываются, клиенту посчитается более дешёвая.',

  // Расписание
  scheduleTitle: 'Часы работы',
  scheduleHint: 'Клиент увидит только те промежутки, когда вы работаете.',
  scheduleDayOff: 'Выходной',
  scheduleFrom: 'с',
  scheduleTo: 'до',
  scheduleSave: 'Сохранить расписание',
  scheduleSaved: 'Расписание сохранено',
  scheduleAllClosed: 'Отметьте хотя бы один рабочий день',
  scheduleBadHours: 'Начало дня должно быть раньше конца',
  weekday_0: 'Воскресенье',
  weekday_1: 'Понедельник',
  weekday_2: 'Вторник',
  weekday_3: 'Среда',
  weekday_4: 'Четверг',
  weekday_5: 'Пятница',
  weekday_6: 'Суббота',
  daysOffTitle: 'Выходные дни',
  daysOffHint: 'Отдельные даты, когда вы не работаете.',
  daysOffEmpty: 'Выходных не отмечено',
  daysOffAdd: 'Добавить выходной',
  daysOffRemove: 'Убрать',

  // Связь и выплаты
  payoutTitle: 'Связь и оплата',
  payoutPhoneLabel: 'Телефон для связи',
  payoutPhoneHint: 'По нему с вами свяжется клиент или администратор.',
  payoutPhoneInvalid: 'Формат: +998XXXXXXXXX',
  payoutCardLabel: 'Карта для выплат',
  payoutCardHint: 'На эту карту с вами рассчитывается площадка. Клиенту она не показывается: он платит вам наличными.',
  payoutCardInvalid: 'Номер карты — 16 цифр',
  payoutHolderLabel: 'Владелец карты',
  payoutSave: 'Сохранить',

  // Подтверждение заказа исполнителем
  orderConfirm: 'Принять заказ',
  orderConfirmByAdmin: 'Заказ подтверждает администратор',

  // ── Статусы заказа ────────────────────────────────────────────────────
  status_new: 'Принят, ждёт подтверждения',
  status_confirmed: 'Подтверждён',
  status_assembled: 'Собран',
  status_on_the_way: 'Курьер в пути',
  status_delivered: 'Доставлен',
  status_cancelled: 'Отменён',
  status_failed: 'Не доставлен',

  // ── Отправка телефона в приложении ──────────────────────────────────────
  sharePhoneButton: '📱 Поделиться номером',
  sharePhoneChecking: 'Проверяем…',
  sharePhoneRetry: 'Проверить ещё раз',
  sharePhoneDeclined: 'Номер не отправлен. Можно попробовать ещё раз в любой момент.',
  sharePhoneUnsupported: 'Обновите Telegram, чтобы поделиться номером прямо здесь.',

  // ── Ошибки геолокации внутри мини-аппа ──────────────────────────────────
  locationDenied: 'Доступ к геолокации запрещён.',
  openLocationSettings: 'Открыть настройки',
  retryLocation: 'Попробовать снова',
  locationUnsupported: 'Ваша версия Telegram не поддерживает автоматическое определение — укажите точку на карте.',
  locationError: 'Не удалось определить местоположение.',
  sendLocationViaBot: 'Отправить геолокацию через бота',
  lastLocationBanner: 'Мы получили вашу геолокацию из бота — использовать её?',
  lastLocationUse: 'Использовать эту точку',
  dismiss: 'Не сейчас',
} as const;

/**
 * Ключи словаря выводятся из русского.
 *
 * Отсюда и требование к `uz`: он объявлен как `Record<Key, string>`, поэтому
 * пропущенный перевод не соберётся. Это единственное, что удерживает словари
 * в синхронности — глазами такое не отслеживают.
 */
export type Key = keyof typeof ru;
